// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__fU-px","col":"styles_col__342Ky"};